export class Constants {
  static API = class {
    static BaseURL: string = "http://localhost:7071/api/";
  };

  static PolicyLinks = class {
    static TermsOfUse: string = 'https://www.aggroloans.com/terms-of-use';
  };
}